import { useState } from 'react';
import { PricingSection } from '@/components/home/PricingSection';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import { useSubscription } from '@/hooks/use-subscription';
import { useSubscriptionFunctions } from '@/hooks/use-subscription-functions';

export default function PricingPage() {
  const [selectedTab, setSelectedTab] = useState<'customers' | 'studios'>('customers');
  const { isAuthenticated, userRole } = useAuth();
  const { subscription } = useSubscription();
  const { handleCheckout } = useSubscriptionFunctions();
  
  // Handle checkout process
  const onUpgrade = (plan: string) => {
    if (!isAuthenticated) {
      // Redirect to auth page
      window.location.href = `/auth?redirect=${encodeURIComponent('/pricing')}&action=signup`;
      return;
    }
    
    handleCheckout(plan);
  };
  
  return (
    <div className="min-h-screen bg-[#212121]">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h1 className="text-3xl md:text-5xl font-bold mb-4 text-white">
            Preise für Kunden & Studios
          </h1>
          <p className="text-lg text-gray-300">
            Wählen Sie den passenden Plan für Ihre Bedürfnisse
          </p>
        </div>
        
        <PricingSection 
          initialTab={selectedTab} 
          onTabChange={(tab) => setSelectedTab(tab as 'customers' | 'studios')} 
          onPlanSelect={onUpgrade}
          currentPlan={subscription?.plan}
          showLoginButton={!isAuthenticated}
        />
        
        <div className="mt-16 text-center">
          <h2 className="text-2xl font-bold mb-6 text-white">Häufig gestellte Fragen</h2>
          
          <div className="max-w-3xl mx-auto space-y-6 text-left">
            <div className="bg-[#2A2A2A] p-6 rounded-lg">
              <h3 className="font-semibold text-lg mb-2 text-white">Wie kann ich meinen Plan ändern?</h3>
              <p className="text-gray-300">
                Sie können jederzeit zu einem höheren Plan wechseln. Um einen Plan zu ändern, 
                gehen Sie zu Ihrem Konto und wählen Sie "Plan ändern" im Abonnement-Bereich.
              </p>
            </div>
            
            <div className="bg-[#2A2A2A] p-6 rounded-lg">
              <h3 className="font-semibold text-lg mb-2 text-white">Wie funktioniert die Abrechnung?</h3>
              <p className="text-gray-300">
                Die Abrechnung erfolgt monatlich. Sie können jederzeit kündigen. 
                Nach der Kündigung läuft Ihr Abonnement bis zum Ende des Abrechnungszeitraums.
              </p>
            </div>
            
            <div className="bg-[#2A2A2A] p-6 rounded-lg">
              <h3 className="font-semibold text-lg mb-2 text-white">Was ist im CHRONA Pro Kunden-Plan enthalten?</h3>
              <p className="text-gray-300">
                Für nur 1€ pro Monat erhalten Sie unbegrenzte Buchungen, Zugang zu Add-ons und 
                die Möglichkeit zum Kalender-Export. Ideal für regelmäßige Nutzer unserer Plattform.
              </p>
            </div>
          </div>
          
          <Button 
            className="mt-8 bg-[#2C6E49] hover:bg-[#4C956C] text-white"
            size="lg"
            onClick={() => window.location.href = '/kontakt'}
          >
            Weitere Fragen? Kontaktieren Sie uns
          </Button>
        </div>
      </div>
    </div>
  );
}
